module.exports = __webpack_public_path__ + "img/build.518c8419.png";